import { render, staticRenderFns } from "./galleryTags.vue?vue&type=template&id=39b11a61&scoped=true&"
import script from "./galleryTags.vue?vue&type=script&lang=js&"
export * from "./galleryTags.vue?vue&type=script&lang=js&"
import style0 from "./galleryTags.vue?vue&type=style&index=0&id=39b11a61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b11a61",
  null
  
)

export default component.exports